/**
 * Created by Litong on 17/8/22.
 * http配置
 */

import axios from 'axios'
import store from 'store'
import * as Util from 'util'

// import router from './index'
import Qs from 'qs'

// axios 配置
axios.defaults.timeout = 30000
axios.defaults.baseURL = ''
axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// http request 拦截器
axios.interceptors.request.use(
  config => {
    let prefix = '&'
    if (store.state.userInfo) {
      if (config.url.indexOf('?') === -1) {
        prefix = '?'
      }
      config.url += prefix
      if (!/LENOVO/.test(config.url)) {
        config.url += 'X-LENOVO-SESS-ID=' + store.state.userInfo['X-LENOVO-SESS-ID']
      }
      config.url += '&_=' + new Date().getTime()
    }
    if (config.url.indexOf('?') === -1) {
      prefix = '?'
    } else {
      prefix = '&'
    }
    if (Util.getCookie('S')) {
      config.url += prefix + 'S=' + Util.getCookie('S')
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      console.log(JSON.stringify(error)) // console : Error: Request failed with status code 402
    }
    return Promise.reject(error.response.data)
  })

export function ajaxGet (url, params) {
  return new Promise((resolve, reject) => {
    url = url.replace(/\+/g, '%2B')
    url = url.replace(/#/g, '%23')
    axios.get(url, params)
      .then(response => {
        // console.log('get' + response)
        if (response) {
          resolve(response.data)
        }
      }, err => {
        resolve(err)
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function ajaxPost (url, params) {
  return new Promise((resolve, reject) => {
    url = url.replace(/\+/g, '%2B')
    url = url.replace(/#/g, '%23')
    axios.post(url, Qs.stringify(params)) // Qs是对post请求参数一个转换
      .then(response => {
        console.log(response)
        resolve(response.data)
      }, err => {
        reject(err)
        resolve(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/router/http.js